import api from './api';

export const instagramService = {
    // Get Instagram posts
    getPosts: async () => {
        const response = await api.get('/instagram/posts');
        return response.data;
    },

    // Link Instagram account (admin)
    linkAccount: async (accessToken) => {
        const response = await api.post('/instagram/link', { accessToken });
        return response.data;
    },

    // Sync Instagram posts (admin)
    syncPosts: async () => {
        const response = await api.post('/instagram/sync');
        return response.data;
    },

    // Get Instagram status (admin)
    getStatus: async () => {
        const response = await api.get('/instagram/status');
        return response.data;
    },
};

